import { useSettingsStore } from '@/state/useSettingsStore'
import clsx from 'clsx'
import { Moon, Sun, SunMoon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ThemeSwitcher() {
  const { t } = useTranslation()
  const theme = useSettingsStore((s) => s.theme)
  const setTheme = useSettingsStore((s) => s.setTheme)

  const options: { id: typeof theme; icon: typeof Moon; label: string }[] = [
    { id: 'light', icon: Sun, label: t('settings.themeLight') },
    { id: 'dark', icon: Moon, label: t('settings.themeDark') },
    { id: 'auto', icon: SunMoon, label: t('settings.themeAuto') },
  ]

  return (
    <div className="inline-flex items-center rounded-full border border-border bg-surface-1/80 p-0.5">
      {options.map((o) => {
        const Icon = o.icon
        const active = theme === o.id
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => setTheme(o.id)}
            title={o.label}
            className={clsx(
              'inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition',
              active ? 'bg-brand-primary text-ink-inverse' : 'text-ink-muted hover:text-ink',
            )}
          >
            <Icon className="size-3.5" />
            <span>{o.label}</span>
          </button>
        )
      })}
    </div>
  )
}
